import React from 'react';
import Ayurveda2026 from 'views/Ayurveda2026';

const AccountGeneralPage = () => {
  return <Ayurveda2026 />;
};

export default AccountGeneralPage;
